export default __webpack_public_path__ + "static/media/b2.afca99b0.webp";